module.exports = __webpack_public_path__ + "static/media/tagManager.7dff9bb9.png";